import userGroupsMutations from "./mutations.js";
import userGroupsActions from "./actions.js";
import userGroupsGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {

    };
  },
  mutations: userGroupsMutations,
  actions: userGroupsActions,
  getters: userGroupsGetters,
};
